import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import configReducer, {
  configurationInitialState,
} from "./store/config/configurationSlice";
import breadcrumReducer, {
  BreadcrumInitialState,
} from "./store/webform/BreadcrumSlice";
import webformReducer, {
  WebFormInitialState,
} from "./store/webform/WebFormSlice";
import { reducer as formReducer } from "redux-form";
export const INITIAL_STATE = {
  config: configurationInitialState(),
  breadcrum: BreadcrumInitialState(),
  webform: WebFormInitialState(),
};

const combineReducer = combineReducers({
  form: formReducer,
  config: configReducer,
  breadcrum: breadcrumReducer,
  webform: webformReducer,
});

const rootReducer = (state, action) => {
  return combineReducer(state, action);
};

export default configureStore({
  reducer: rootReducer,
  middleware: [...getDefaultMiddleware({ serializableCheck: false })],
  preloadedState: INITIAL_STATE,
});
